<script setup>
defineProps({
  direction: {
    type: String,
    required: false,
    default: 'right',
    validator: (value) => ['left', 'right'].includes(value),
  },
})
</script>

<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="12"
    height="12"
    viewBox="0 0 12 12"
    :class="[{ 'rotate-180': direction === 'left' }]"
  >
    <path
      fill="currentColor"
      fill-rule="evenodd"
      d="M8.05593719,6.93637604 L1.85377821,6.93637604 C0.715407262,6.93637604 0.715407262,5.04354348 1.85377821,5.04354348 L8.05593719,5.04354348 L5.85770363,2.63448386 C5.03336605,1.7310865 6.25024534,0.397499928 7.07458292,1.30089729 L10.764475,5.34467593 C11.0785083,5.68882731 11.0785083,6.29109221 10.764475,6.67826251 L7.07458292,10.7220412 C6.25024534,11.5824196 5.03336605,10.248833 5.85770363,9.38845458 L8.05593719,6.93637604 Z"
      transform="matrix(1 0 0 -1 0 12)"
    />
  </svg>
</template>
